import { t } from 'ttag'
import { useQuery } from 'react-query'
import { useState, useMemo, useContext, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { api } from '@h2/api'
import { Globals } from '@h2/globals'
import { Alert } from '@h2/components/display/alert'
import { Text } from '@h2/components/typography/text'
import { SO50S } from '@h2/components/colors'

import { EmailConfirmationDialog } from '../emailConfirmationDialog'
import { emailConfirmationDialog } from '../../selectors/emailConfirmationDialog'
import { setUser } from '../../actions/setUser'
import { toggleEmailConfirmationDialog } from '../../actions/toggleEmailConfirmationDialog'

const Message = ({ isSubscriber }) => (
  <Text size="large" weight="bold" color={SO50S}>
    {isSubscriber
      ? t`An administrator needs to approve your account to start using the CareerExplorer as a Navigator`
      : t`You need to confirm your email address to start using the CareerExplorer as a Navigator`}
  </Text>
)
const EmailConfirmationWarning = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { user, isSubscriber } = useContext(Globals)
  const emailConfirmationDialogState = useSelector(emailConfirmationDialog)
  const showEmailWarning = useMemo(() => user.isNavigator && !user.hasManager, [user])
  const [refetchInterval, setRefetchInterval] = useState(showEmailWarning ? 5000 : false)

  // Poll dynamicValues so new registrants get a real-time response to email confirmation
  useQuery('dynamicValues', () => api.fetch('/siteConfig/dynamicValues'), {
    refetchInterval,
    refetchIntervalInBackground: true,
    onSuccess: ({ userProfile }) => {
      if (userProfile?.hasManager) {
        dispatch(setUser(userProfile))
        setRefetchInterval(false)
      }
    }
  })

  useEffect(() => {
    if (window.localStorage.getItem('showConfirmationDialog')) {
      window.localStorage.removeItem('showConfirmationDialog')
      dispatch(toggleEmailConfirmationDialog('open'))
    }
  }, [dispatch])

  if (/requestmanagement\/confirm/.test(location.pathname)) {
    return null
  }

  if (showEmailWarning) {
    return (
      <>
        <Alert
          type="warning"
          isDismissible={false}
          margin="5px 0 20px 0"
          message={<Message isSubscriber={isSubscriber} />}
          onClick={() => dispatch(toggleEmailConfirmationDialog('open'))}
        />
        {emailConfirmationDialogState === 'open' && (
          <EmailConfirmationDialog
            onClose={() => dispatch(toggleEmailConfirmationDialog('closed'))}
          />
        )}
      </>
    )
  }

  return null
}

export { EmailConfirmationWarning }
